
export default function Option({ opt, position, handledelete }) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{ borderStyle: "none" }}>
            <td className="text-center">{position + 1}</td>
            <td>{opt?.label !== null ? opt?.label : ""}</td>
            <td className="text-center">
                <button type="button" onClick={handledelete} data-toggle="tooltip" title={`Supprimer l'élément`} data-placement="left" className="btn-shadow-danger mr-2 ml-2 btn btn-sm btn-danger">
                    <i className="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    )
}